import { TRANSLATIONS as text } from '../../translations';
import mapNextDayDeliveryOption from '../mapNextDayDeliveryOption/mapNextDayDeliveryOption';

const { deliveryOptions } = text;

const labelToServiceCopy = {
  'Next day': deliveryOptions.type.nextDay,
  Fastest: deliveryOptions.type.fastest,
  Express: deliveryOptions.type.express,
};

const getDeliveryServiceLevel = ({
  serviceLevel,
  shippingAddress,
  customerCollectionDate,
  deliveryDetailKey,
  carrierCode,
} = {}) => {
  const { addressType, country, isBfpo } = shippingAddress ?? {};

  if (serviceLevel === 'express') {
    if (country !== 'GB' || isBfpo) {
      return deliveryOptions.type.express;
    }

    // UK home / shop / store use Next day / Fastest based on Metapack date
    const displayLabel = mapNextDayDeliveryOption({
      isGB: true,
      nextDayOption: {
        deliveryMethod: addressType,
        carrierCode: carrierCode || shippingAddress?.carrierCode,
        deliveryDetails: deliveryDetailKey
          ? [{ key: deliveryDetailKey, date: customerCollectionDate }]
          : [{ date: customerCollectionDate }],
      },
      deliveryDate: customerCollectionDate,
      shippingAddress,
    });

    return labelToServiceCopy[displayLabel] || deliveryOptions.type.express;
  }

  return deliveryOptions.type[serviceLevel] || '';
};

export default getDeliveryServiceLevel;
